var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"el",staticClass:"draggable",style:(_vm.style),on:{"mousedown":_vm.onMouseDown,"touchstart":_vm.onTouchStart}},[_vm._t("default",null,{"dragging":_vm.dragging})],2)}
var staticRenderFns = []

export { render, staticRenderFns }